"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
var replaceContentfulUrl = function (url) {
    if (!url) {
        return undefined;
    }
    return url
        .replace('assets.ctfassets.net', "".concat(constants_1.CTF_WEB_SERVICES_DOMAIN, "/assets"))
        .replace('images.ctfassets.net', "".concat(constants_1.CTF_WEB_SERVICES_DOMAIN, "/images"));
};
exports.default = replaceContentfulUrl;
